"use strict";

var Collection = require('./Collection'),
    Constants = require('../constants'),
    Attribute = require('../models/Attribute'),

    data = [{
        id: 'NAME_ASC',
        name: 'Name A - Z'
    }, {
        id: 'NAME_DESC',
        name: 'Name Z - A'
    }];

var BuilderOrderBy = Collection.extend({
    model: Attribute,
    constructor: function(models, options) {
        models = data;
        return Collection.prototype.constructor.call(this, models, options);
    }
});

module.exports = BuilderOrderBy;
